/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconColorProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Side Nav SideNavTripListIcon Icon component.
 */
export const SideNavTripListIcon = (props: IconColorProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  const filledIconStyle: React.CSSProperties = {stroke: 'none'};
  return (
    <ThemeIconProvider name='TripListIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="11.375" cy="10.375" r="0.75" fill={iconColor} style={filledIconStyle}/>
        <circle cx="11.375" cy="14.375" r="0.75" fill={iconColor} style={filledIconStyle}/>
        <circle cx="11.375" cy="18.375" r="0.75" fill={iconColor} style={filledIconStyle}/>
        <rect x="13.625" y="9.625" width="6" height="1.5" rx="0.75" fill={iconColor} style={filledIconStyle}/>
        <rect x="13.625" y="13.625" width="6" height="1.5" rx="0.75" fill={iconColor} style={filledIconStyle}/>
        <rect x="13.625" y="17.625" width="6" height="1.5" rx="0.75" fill={iconColor} style={filledIconStyle}/>
        <path d="M19.625 5C21.627 5 23.25 6.62297 23.25 8.625V19.625C23.25 21.627 21.627 23.25 19.625 23.25H10.625C8.62297 23.25 7 21.627 7 19.625V14.2783L7.00586 14.2725L7 14.2666C7.00439 14.2704 7.00586 14.2725 7.00586 14.2725L7.00684 14.2715L7.00781 14.2695C7.00781 14.2695 7.01012 14.2665 7.01172 14.2646C7.0149 14.261 7.01916 14.256 7.02441 14.25C7.03505 14.2378 7.05065 14.2209 7.06934 14.1992C7.10671 14.1559 7.15932 14.0938 7.22559 14.0156C7.35847 13.8588 7.54616 13.6346 7.76953 13.3594C7.91525 13.1798 8.07648 12.9763 8.25 12.7549V19.625C8.25 20.9367 9.31332 22 10.625 22H19.625C20.9367 22 22 20.9367 22 19.625V8.625C22 7.31332 20.9367 6.25 19.625 6.25H11.9756C12.0675 5.85745 12.125 5.45235 12.125 5.0459C12.125 5.03058 12.1241 5.01529 12.124 5H19.625Z" fill={iconColor}
          style={filledIconStyle}/>
        <circle cx="5.125" cy="5.125" r="1.5" fill={iconColor} style={filledIconStyle}/>
        <path d="M9.625 5.04605C9.625 7.48773 5.125 12.625 5.125 12.625C5.125 12.625 0.625 7.48773 0.625 5.04605C0.625 2.60437 2.63972 0.625 5.125 0.625C7.61028 0.625 9.625 2.60437 9.625 5.04605Z" stroke={iconColor} strokeWidth="1.25"/>
      </svg>
    )} />
  );
};

export default SideNavTripListIcon;
